<thds-page-header pageTitle="Layouts"></thds-page-header>

<div class="mt-2">
  <button
    class="dl-tab bg-white px-6 py-2 rounded-tl-2xl"
    routerLink="/layouts/monatsauswertungen"
    routerLinkActive="active-tab"
  >
    Monatsauswertungen - Layouts
  </button>
  <button
    class="dl-tab bg-white px-6 py-2 rounded-tr-2xl"
    routerLink="/layouts/aggregierteauswertungen"
    routerLinkActive="active-tab"
  >
    Aggregierte Auswertungen - Layouts
  </button>
</div>

<!-- Monatsauswertungen Layouts -->
@if ((componentStore.mode$ | async)?.includes('monatsauswertungen')) {
  <div
    class="grid h-[calc(100%-6rem)] bg-white relative grid-cols-edit-list rounded-b-2xl rounded-tr-2xl"
  >
    <div class="bg-neutral-50 p-4 rounded-bl-2xl">
      <thds-monatsauswertungen-layouts-list
        (create)="onCreateMonatsauswertungen()"
        *ngLet="monatsauswertungenLayouts$ | async as monatsauswertungenLayouts"
        [monatsauswertungenLayouts]="monatsauswertungenLayouts ?? []"
        [selectedLayoutId]="
          componentStore.selectedMonatsauswertungLayoutId$ | ngrxPush
        "
      >
      </thds-monatsauswertungen-layouts-list>
    </div>
    <dl-spinner
      *ngIf="componentStore.loading$ | async"
      class="absolute top-0 left-0 right-0 bottom-0 bg-neutral-700 bg-opacity-40"
    ></dl-spinner>
    <thds-monatsauswertungen-layouts-editor
      (submitForm)="onSubmit($event)"
      *ngIf="
        (componentStore.mode$ | async) === 'monatsauswertungen-edit' ||
          (componentStore.mode$ | async) === 'monatsauswertungen-create';
        else placeholder
      "
      [monatsauswertungLayout]="
        componentStore.selectSelectedMonatsauswertungLayout$ | ngrxPush
      "
    >
    </thds-monatsauswertungen-layouts-editor>
  </div>
} @else if (
  (componentStore.mode$ | async)?.includes('aggregierteauswertungen')
) {
  <!-- Aggregierte Auswertungen Layouts -->
  <div
    class="grid h-[calc(100%-6rem)] bg-white relative grid-cols-edit-list rounded-b-2xl rounded-tr-2xl"
  >
    <div class="bg-neutral-50 p-4 rounded-bl-2xl">
      <thds-aggregierteauswertungen-layouts-list
        (create)="onCreateAggregierteAuswertungen()"
        *ngLet="
          aggregierteAuswertungenLayouts$
            | async as aggregierteauswertungenLayouts
        "
        [aggregierteAuswertungenLayouts]="aggregierteauswertungenLayouts ?? []"
        [selectedLayoutId]="
          componentStore.selectedAggregierteAuswertungLayoutId$ | ngrxPush
        "
      >
      </thds-aggregierteauswertungen-layouts-list>
    </div>
    <dl-spinner
      *ngIf="componentStore.loading$ | async"
      class="absolute top-0 left-0 right-0 bottom-0 bg-neutral-700 bg-opacity-40"
    ></dl-spinner>
    <thds-aggregierteauswertungen-layouts-editor
      (submitForm)="onSubmitAggregierteAuswertungen($event)"
      *ngIf="
        (componentStore.mode$ | async) === 'aggregierteauswertungen-edit' ||
          (componentStore.mode$ | async) === 'aggregierteauswertungen-create';
        else placeholder
      "
      [aggregierteAuswertungLayout]="
        componentStore.selectSelectedAggregierteAuswertungLayout$ | ngrxPush
      "
    >
    </thds-aggregierteauswertungen-layouts-editor>
  </div>
}

<ng-template #placeholder>
  <div class="flex justify-center items-center">
    <span class="text-xl text-center">
      Bitte wählen Sie ein Layout aus der Liste aus
    </span>
  </div>
</ng-template>
